import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommandService } from '../shared/services/command.service';
import { IControlInput, IDeviceInformation } from '../shared/models/device';
import { IDeviceInputComponent } from './device-input.interface';
import {
    CommandOptimizationRenderingService,
    CachedObject,
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';
import { Subscription } from 'rxjs';

// Base controller from which input type specific controllers are derived.
@Component({
    template: '',
})
export class DeviceInputBaseComponent implements IDeviceInputComponent, OnInit, OnDestroy {
    @Input() public deviceInfo: IDeviceInformation;
    @Input() public deviceInput: IControlInput;
    @Input() public hideTitle = false;

    /** These two are tied together, modify them together or break! */
    @Input() public deviceInputForm: FormGroup;
    public formName: string = 'deviceInputForm';

    public hasDeviceInput: boolean = true;
    private _commandService: CommandService;
    private inputChangedSubscription: Subscription;

    constructor(
        commandService: CommandService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        this._commandService = commandService;
    }

    ngOnInit() {
        this.validateBindings();
        this.commandOptimizationRenderingService.storeSensorToCache(
            this.deviceInput?.sensorId,
            this.deviceInput as CachedObject);
        this.inputChangedSubscription = this.commandOptimizationRenderingService
            .observeSensorChanges(this.deviceInput?.sensorId)?.subscribe(updatedDeviceInput => {
            this.deviceInput = {...this.deviceInput, ...updatedDeviceInput};
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
        this.inputChangedSubscription?.unsubscribe();
        this.commandOptimizationRenderingService.removeSensorFromCache(this.deviceInput?.sensorId);
    }

    protected invokeChangeCommand(controlInput: IControlInput) {
        // May want to do other things besides invoke commands, they'll run here.
        // These functions don't consider validity
        if (controlInput.$onChange) {
            controlInput.$onChange();
        }

        // Below this point does consider validity
        if (this.deviceInputForm.valid && this.deviceInfo) {
            this.deviceInfo.$deviceHierarchy.$flatControlInputs.find(a => a.$fieldName === controlInput.$fieldName).value = controlInput.value;
            if (controlInput.changeCommand) {
                this._commandService.invokeCommand(this.deviceInfo, controlInput.changeCommand.action);
            }
        }
    }

    private validateBindings() {
        let mustBePresent = 'must be present for all DeviceInputControllers. Check directive/component bindings.';

        // tslint:disable no-console
        if (!this.deviceInfo) {
            console.warn(`deviceInfo ${mustBePresent}`);
        }

        if (!this.deviceInput) {
            console.warn(`deviceInput ${mustBePresent}`);
        }

        if (!this.deviceInputForm) {
            console.warn(`deviceInputForm ${mustBePresent}`);
        }
        // tslint:enable no-console
    }
}
